import { h } from 'preact';
import { useEffect } from 'preact/hooks';

export default function Modal({ isOpen, title, onClose, children }) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div class="modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">{title}</h3>
          <button class="modal-close" onClick={onClose}>&times;</button>
        </div>
        <div class="modal-body">{children}</div>
      </div>
    </div>
  );
}
